import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabItemDirective, TabItemsDirective } from './items.directive';
import { TabComponent } from './tab.component';
/**
 * NgModule definition for the Tab component.
 */
export class TabModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        TabComponent,
        TabItemDirective,
        TabItemsDirective
    ],
    exports: [
        TabComponent,
        TabItemDirective,
        TabItemsDirective
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TabModule_tsickle_Closure_declarations() {
/** @type {?} */
TabModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TabModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
